<template>
<div class="notification">
  <div v-for="(notification, index) in notifications" v-bind:key="index">
    <div class="toast add-margin" :class="classes(notification)" :ref="notification.id" v-if="notification.visible && notification.title">
      <div class="toast__icon">
        <div v-if="notification.type == 'info'">
          <div class="icon-container">
            <i class="icon yule-icon-info"></i>
          </div>
        </div>
        <div v-else-if="notification.type == 'error'">
          <div class="icon-container">
            <i class="icon yule-icon-alert"></i>
          </div>
        </div>
        <div v-else-if="notification.type == 'success'">
          <div class="icon-container">
            <i class="icon yule-icon-success"></i>
          </div>
        </div>
      </div>
      <div class="toast__content">
        <p class="toast__type">{{$t(notification.title)}}</p>
      </div>
      <div class="toast__close" @click="close(notification)">
        <i class="icon yule-icon-close-small"></i>
      </div>
    </div>
  </div>
</div>
</template>

<script>
/*
  This component is rendered always from App.vue. This means that any component in the app can add a notification to the store
  and it will automatically be displayed. A max of 5 notifications can be displayed at the same time. Any excess notifications are ignored.
  Add a notification like so:

  this.$store.commit('SET_NOTIFICATION', {
    'title': 'models.project_lead.found_existing', // Required
    'type': 'success',                             // Optional - defaults to info
    'duration_ms': 6000,                           // Optional - defaults to 50ms per character with a minimum of 4500ms and maximum of 7500ms
    'classes': ['cssClass1', 'cssClass2']          // Optional - extra CSS classes
  })
*/
export default {
  computed: {
    notifications() {
      return this.$store.getters.getNotifications
    }
  },
  watch: {
    notifications: {
      handler() {
        if (this.notifications.length > 0) {
          this.setCloseAutomaticallyTimeouts()
        }
      }
    }
  },
  methods:{
    close(notification) {
      let dom_element = this.$refs[notification.id][0]
      if (dom_element) {
        dom_element.classList.add('closed')
        // For some reason we have to remove the older animation
        dom_element.classList.remove('animateOpen')
        setTimeout(() => {
          this.$store.commit('SET_NOTIFICATION_CLOSED', notification.id)
        }, 700)
      }
    },
    setCloseAutomaticallyTimeouts() {
      // Close notifications automatically after max duration is reached
      this.notifications.forEach((notification) => {
        if (notification.duration_ms > 0) {
          setTimeout(() => {
            this.close(notification)
            clearTimeout()
          }, notification.duration_ms)
        }
      })
    },
    isStatic(notification) {
      return notification.duration_ms === 0
    },
    classes(notification) {
      let classes = [notification.type, notification.classes]
      if (this.isStatic(notification)) {
        classes.push('is-static')
      } else {
        classes.push('is-flash')
      }
      return classes
    }    
  }
}
</script>

<style lang="scss">
.toast__container {
  display: table-cell;
  vertical-align: middle;
}

.add-margin{
  margin-top:20px;
}

.toast__svg{
  fill:#fff;
}

.icon-container {
  background-color: #fff;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.toast {
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align:left;
  padding: 13px 0;
  background-color:#fff;
  border-radius:4px;
  top: 0px;
  position:relative;  
  color: #45565B;
  height: 56px;
}

.toast.is-flash {
  -webkit-box-shadow: 0 20px 66px 0 rgba(34,48,73,0.2);
  box-shadow: 0 20px 66px 0 rgba(34,48,73,0.2);
}

.info {
  background: $blue-lighter;
  .yule-icon-info {
    color: $blue;
  }
}

.error {
  background-color: $red-lighter;
  .yule-icon-alert {
    color: $red;
  }
}

.success {
  background: $green-lighter;
  .yule-icon-success {
    color: $green;
  }
}

.notification {
  position: fixed;
  bottom: 7%;
  left: 0px;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  width: 55%;
  max-width: 700px;
  z-index: 100;
}

@media(max-width: 600px) {
  .notification {
    width: 90%;
  }
}

.toast__icon{
  position:absolute;
  top:50%;
  left:10px;
  transform:translateY(-50%);
  padding: 7px;
  border-radius:50%;
  display:inline-block;
}

.toast__type {
  font-weight: $font-medium;
  margin-top: 0;
  margin-bottom: 0;
  line-height: 1;
  overflow: hidden;
}

.toast__message {
  font-size: 14px;
  margin-top: 0;
  margin-bottom: 0;
  color: #45565B;
}

.toast__content{
  width: 95%;
  padding-left:70px;
  padding-right:60px;
}

.toast__close {
  position: absolute;
  right: 22px;
  cursor:pointer;
  fill:#878787;
  .icon {
    font-size: .9em;
  }
}

.closed {
  animation: closed 0.7s;
  animation-fill-mode: forwards;
	-webkit-animation: closed 0.7s;
  -webkit-animation-fill-mode: forwards;
}

.animateOpen{
  animation: moveOpen 0.5s;
  animation-fill-mode: forwards;
	-webkit-animation:moveOpen 0.5s;
  -webkit-animation-fill-mode: forwards;
}

/* Safari and Chrome */
@-webkit-keyframes closed {
  from {opacity: 1;}
  to {opacity: 0;}
}

/* Safari and Chrome */
@-webkit-keyframes moveOpen {
  from {-webkit-transform: translate(0,100px);}
  to {-webkit-transform: translate(0,0px);}
}
</style>



// WEBPACK FOOTER //
// Notification.vue?98a5c082